'use client'

import { useEffect, useState } from 'react'

import { newRelicNotifyError } from '@/utils/trackingNewRelic'

import styles from './Icon.module.scss'

const cachedIcons = new Map()

export const Icon = ({
  name,
  color = 'blue',
  size = 'small',
  customClass,
  bgcolor,
  round
}) => {
  const [svgContent, setSvgContent] = useState('')

  useEffect(() => {
    if (cachedIcons.has(name)) {
      setSvgContent(cachedIcons.get(name))
      return
    }

    fetch(`${basePath}icons/${name}.svg`) // eslint-disable-line no-undef
      .then((res) => {
        if (res.ok) return res.text()
        throw new Error(res.statusText)
      })
      .then((data) => {
        cachedIcons.set(name, data)
        setSvgContent(data)
      })
      .catch((err) => {
        newRelicNotifyError(
          `Error - import icon ${name}: ${JSON.stringify(err)}`
        )
      })
  }, [name])

  return (
    <>
      <span
        data-name={name}
        aria-hidden="true"
        className={`
            ${styles.icon}
            ${styles['icon__color--' + color]}
            ${styles['icon__size--' + size]}
            ${styles['icon__background--' + bgcolor]}
            ${round && styles['icon__background--round']}
            ${customClass}
          `}
        dangerouslySetInnerHTML={{ __html: svgContent }}
      />
    </>
  )
}
